import React from "react";
import { Link } from "react-router-dom";
import { Logo } from "@/components/Logo";
import { useI18n } from "@/i18n";

export function Footer() {
  const { t } = useI18n();
  return (
    <footer className="bg-midnight text-white" data-testid="site-footer">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 py-20">
        <div className="flex flex-col md:flex-row justify-between gap-10">
          <div className="max-w-md">
            <Logo dark />
            <p className="mt-6 overline text-champagne">{t.footer.missionLabel}</p>
            <p className="mt-3 font-serif text-2xl md:text-3xl italic text-white/80 leading-snug">{t.footer.tagline}</p>
          </div>
          <div className="flex gap-16">
            <div className="flex flex-col gap-3">
              <span className="overline text-champagne">JetSeat</span>
              <span className="text-white/60 text-sm">Milano · Roma · Venezia</span>
              <span className="text-white/60 text-sm">hello@jetseat.io</span>
            </div>
            <div className="flex flex-col gap-3">
              <span className="overline text-champagne">Legal</span>
              <Link to="/admin/login" data-testid="footer-admin-link" className="text-white/60 text-sm link-underline">
                {t.footer.admin}
              </Link>
            </div>
          </div>
        </div>
        <div className="mt-16 pt-8 border-t border-white/10 flex flex-col sm:flex-row justify-between gap-2 text-white/40 text-xs">
          <span>© {new Date().getFullYear()} JetSeat. {t.footer.rights}</span>
          <span className="tracking-[0.2em] uppercase">Asset-light · AOC partners</span>
        </div>
      </div>
    </footer>
  );
}
